export default {
  en: {
    data_model_name: "{0} Data Model"
  },
  es: {
    data_model_name: "Modelo de Datos {0}"
  },
  ca: {
    data_model_name: "Model de Dades {0}"
  }
};
